import { useMemo } from "react";

import { useDestinationConfigSaasDestinationPairs } from "@/hooks/useDestinationConfigSaasDestinationPairs";

/**
 * Returns the enabled destinations that can be categorized for consent
 * management. Disabled destinations are excluded so they never appear in the
 * category mapping UI and — importantly — never sit in the form's
 * `consentMapping` where a stale entry could silently block publishing without
 * a visible error. Audience destinations are excluded too; they are
 * categorized separately.
 */
export function useConsentCategorizableDestinations() {
  const destinationPairs = useDestinationConfigSaasDestinationPairs();

  return useMemo(() => {
    return destinationPairs.filter(({ saasDestination, destinationConfig }) => {
      if (!destinationConfig.enabled) return false;
      if (saasDestination.destinationCategories.includes("Audiences")) {
        return false;
      }
      return true;
    });
  }, [destinationPairs]);
}
